// extracted by mini-css-extract-plugin
module.exports = {"outline":"_2ofQ-yTQ","title":"_2YIDR5bt","icon":"_36qldBVS","spBackground":"_1kblABB0"};